import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { LoginResponseInfoEntity } from "@/domain/entity/login-response-info-entity";
import { AuthRepository } from "@/domain/repository/auth-repository";
import { LoginRepository } from "@/domain/repository/login-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LoginUsecase {
  constructor(
    private readonly loginRepo: LoginRepository,
    private readonly authRepo: AuthRepository,
  ) {}

  async execute(email: string, password: string): Promise<SATResult<LoginResponseInfoEntity, SATError>> {
    const loginPayload: LoginRequestPayload = {
      loginId: email,
      sn: password,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Seoul",
    };

    const loginResult = await this.loginRepo.login(loginPayload);
    if (loginResult.isFailure) {
      return SATResult.failure(loginResult.error);
    }

    const keyResult = await this.authRepo.exchangeAndSaveAESecretKeyByCookie();
    if (keyResult.isFailure) {
      return SATResult.failure(keyResult.error);
    }

    return SATResult.success(loginResult.value);
  }
}
